<template>
  <v-container>
    <v-layout row wrap>
      <v-flex xs12>
        <v-card>
          <v-progress-circular v-show="loading" color="primary" indeterminate />
          <v-card-text>
            <v-form v-model="form.valid" ref="form" lazy-validation>
              <v-text-field
                v-model="news.title"
                label="Título"
                prepend-icon="title"
                :rules="[form.rules.required]"
                required
              ></v-text-field>
              <v-text-field
                v-model="news.link"
                label="Link de youtube"
              ></v-text-field>
              <template>
                <v-select
                  :items="newCategories"
                  label="Seleccione la categoria"
                  v-model="news.category"
                  name="category"
                  :rules="[form.rules.required]"
                  item-text="name"
                ></v-select>
              </template>
              <v-textarea
                class="mt-10"
                v-model="news.description"
                name="input-7-1"
                label="Descripción"
                :rules="[form.rules.required]"
                required
                height="50"
              ></v-textarea>
              <!-- <vuetify-google-autocomplete
                v-model="news.place"
                id="map"
                prepend-icon="directions"
                placeholder="Lugar"
                v-on:placechanged="getAddressData"
                :clearable="true"
                :disabled="false"
                country="DO"
                :types="'geocode'"
                :required="true"
              ></vuetify-google-autocomplete>-->
              <tiptap-vuetify
                v-model="news.content"
                :extensions="extensions"
                :card-props="{ color: '#fcfcfc' }"
              ></tiptap-vuetify>
              <v-row>
                <v-col
                  v-for="(image, index) in images"
                  :key="index"
                  cols="12"
                  md="4"
                >
                  <v-card color="#fcfcfc" flat>
                    <v-img
                      :src="
                        image.url === undefined
                          ? image.localData || ''
                          : image.url
                      "
                      height="250"
                    ></v-img>
                    <v-card-actions>
                      <v-spacer />
                      <input
                        type="file"
                        style="display: none"
                        :ref="index + '-image'"
                        accept="image/*"
                        @change="onFilePicked"
                      />
                      <v-btn
                        @click="pickFile(index)"
                        :color="
                          image.url
                            ? 'red'
                            : image.file === undefined
                            ? 'blue'
                            : 'red'
                        "
                        text
                      >
                        |
                        {{
                          image.url
                            ? "Cambiar foto"
                            : image.file === undefined
                            ? "Cargar foto"
                            : "Cambiar foto"
                        }}
                        <v-icon right>photo_camera</v-icon>
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer />

            <v-btn @click="submit" :disabled="loading" color="green" text
              >Guardar</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import {
  TiptapVuetify,
  Heading,
  Bold,
  Italic,
  Strike,
  Underline,
  Code,
  Paragraph,
  BulletList,
  OrderedList,
  ListItem,
  Link,
  Blockquote,
  HardBreak,
  HorizontalRule,
  History,
} from "tiptap-vuetify";
import { firebase, news, storage } from "../../firebase.config";
import { mapState, mapGetters, mapActions } from "vuex";
export default {
  name: "New",
  props: ["id"],
  components: { TiptapVuetify },
  data: () => ({
    loading: false,
    form: {
      valid: false,
      rules: {
        required: (v) => !!v || "Este campo es requerido",
      },
    },
    extensions: [
      History,
      Blockquote,
      Link,
      Underline,
      Strike,
      Italic,
      ListItem,
      BulletList,
      OrderedList,
      [
        Heading,
        {
          options: {
            levels: [1, 2, 3],
          },
        },
      ],
      Bold,
      Code,
      HorizontalRule,
      Paragraph,
      HardBreak,
    ],
    imageIndex: -1,
    images: [{}, {}, {}],
    news: {
      category: "",
      active: true,
      content: `<h2>Este es el contenido de la noticia</h2><p>Puede especificar cualquier formato que desee, utilizando los componentes que se encuentran en la barra más arriba.</p>`,
    },
  }),
  created() {
    if (!this.isNew) this.loadNews();
    this.loadNewCategories();
  },
  computed: {
    ...mapGetters(["newCategories"]),
    isNew() {
      return this.id === "new";
    },
    title() {
      return this.isNew ? "Crear noticia" : "Editar noticia";
    },
  },
  methods: {
    ...mapActions({
      loadNewCategories: "loadNewCategories",
    }),

    loadNews() {
      let vm = this;

      this.loading = true;

      news
        .doc(this.id)
        .get()
        .then((documentSnapshot) => {
          const news = documentSnapshot.data();
          this.news = {
            id: documentSnapshot.id,
            ...news,
          };
          if (news.images) {
            for (let i = 0; i < news.images.length; i++) {
              vm.images[i].url = news.images[i];
            }
          }
        })
        .catch((error) => this.$emit("show-snackbar", error.message))
        .finally(() => (this.loading = false));
    },

    pickFile(index) {
      this.imageIndex = index;
      this.$refs[index + "-image"][0].click();
    },
    uploadImageAsPromise(imageFile) {
      return new Promise(function(resolve, reject) {
        var storageRef = storage.ref("news/" + Date.now() + ".jpeg");

        //Upload file
        var task = storageRef.put(imageFile);

        //Update progress bar
        task.on(
          "state_changed",
          function(snapshot) {
            var progress =
              (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
            console.log("Upload is " + progress + "% done");
            switch (snapshot.state) {
              case firebase.storage.TaskState.PAUSED:
                console.log("Upload is paused");
                break;
              case firebase.storage.TaskState.RUNNING:
                console.log("Upload is running");
                break;
            }
          },
          function error(err) {
            reject(err);
          },
          function complete() {
            task.snapshot.ref.getDownloadURL().then(function(downloadURL) {
              resolve(downloadURL);
            });
          }
        );
      });
    },
    onFilePicked(e) {
      const files = e.target.files;

      if (files[0] !== undefined) {
        const image = {};

        image.file = files[0];
        image.localData = URL.createObjectURL(files[0]);

        this.$set(this.images, this.imageIndex, image);
      }
    },
    async submit() {
      if (this.$refs.form.validate()) {
        this.loading = true;

        const newsObject = {
          ...this.news,
        };

        const modifiedImages = this.images.filter((i) => i.file !== undefined);
        let modifiedImagesUrl = [];

        console.log(modifiedImages);

        for (const image of modifiedImages) {
          try {
            const downloadUrl = await this.uploadImageAsPromise(image.file);

            modifiedImagesUrl.push(downloadUrl);
          } catch (e) {
            this.loading = false;
            this.$emit("show-snackbar", e.message);
            return;
          }
        }

        if (modifiedImagesUrl.length > 0) newsObject.images = modifiedImagesUrl;

        if (this.isNew)
          newsObject.created = firebase.firestore.Timestamp.fromDate(
            new Date()
          );

        const promise = this.isNew
          ? news.doc().set(newsObject)
          : news.doc(this.id).update(newsObject);

        promise
          .then(() => {
            this.$router.go(-1);
          })
          .catch((error) => {
            debugger;
            this.$emit("show-snackbar", error.message);
          })
          .finally(() => (this.loading = false));
      }
    },
  },
};
</script>
